import { DateTime } from 'luxon';
import { DateFormatPatterns } from '@clearverify/constants';
export const formatReportUpdatedDate = (updatedAt) => {
    const date = typeof updatedAt === 'string' ? new Date(updatedAt) : updatedAt;
    return DateTime.fromJSDate(date).toFormat(DateFormatPatterns.shortDateWithSlash);
};
//# sourceMappingURL=employmentData.js.map